/**
 * Replace `:` in options
 * @param {String} input
 * @returns {String}
 */
const replaceOptionColons = (input) => {
  if (input.includes("<")) {
    return input.replace(/<(.*?)>+/g, (/** @type {String} */ string) => {
      return string.replace(/:/g, "˸");
    });
  } else {
    return input;
  }
};

export default replaceOptionColons;
